import { render, staticRenderFns } from "./BlackjackCard.vue?vue&type=template&id=64306fa1&scoped=true"
import script from "./BlackjackCard.vue?vue&type=script&lang=js"
export * from "./BlackjackCard.vue?vue&type=script&lang=js"
import style0 from "./BlackjackCard.vue?vue&type=style&index=0&id=64306fa1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64306fa1",
  null
  
)

export default component.exports